// JOBE-0163.4 — KpisFraming: KPIs framing for W4 DepartmentPage.
// Dense KpiTile grid scoped to department-level metrics from dept.kpis.
// Tile clicks stub to workstream detail (not yet implemented).

import { KpiTile } from '../components/KpiTile/KpiTile.jsx';
import { Spark }   from '../components/Spark/Spark.jsx';
import './KpisFraming.css';

// Map KPI fixture tone to a Spark-valid tone. Spark accepts ok|warn|bad|ink.
function sparkTone(tone) {
  if (['ok', 'warn', 'bad'].includes(tone)) return tone;
  return 'ink';
}

export default function KpisFraming({ dept }) {
  const kpis = dept?.kpis ?? [];

  if (kpis.length === 0) {
    return <p className="kpis-empty">No KPIs defined for this department.</p>;
  }

  function handleKpiClick(kpi) {
    // TODO(JOBE-0163-followup): wire to /department/:slug/workstream/:id
    // when workstream detail route lands.
    // eslint-disable-next-line no-console
    console.warn('KPIs framing: workstream drill not yet implemented', kpi.id);
  }

  return (
    <div className="kpis-framing" data-testid="framing-kpis">
      <div className="kpi-grid">
        {kpis.map(kpi => (
          <KpiTile
            key={kpi.id}
            label={kpi.label}
            value={kpi.value}
            unit={kpi.unit}
            tone={kpi.tone}
            onClick={() => handleKpiClick(kpi)}
            spark={
              kpi.spark
                ? <Spark
                    mode="absolute"
                    data={kpi.spark}
                    target={kpi.target ?? undefined}
                    tone={sparkTone(kpi.tone)}
                    unit={kpi.unit || ''}
                    ariaLabel={kpi.label}
                  />
                : undefined
            }
          />
        ))}
      </div>
    </div>
  );
}
